import React, {CSSProperties, ReactNode} from "react";
import {InputProps} from "./Input";
import {FieldValues} from "react-hook-form/dist/types/fields";
import Cleave from "cleave.js/react";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import {CleaveOptions} from "cleave.js/options";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {FloatingPortal} from "@floating-ui/react";

export interface InputExProps<T extends FieldValues> extends InputProps<T> {
    input?: JSX.Element
    label?: string | React.ReactNode;
    labelClassName?: string,
    addOnBefore?: JSX.Element | false;
    addOnAfter?: JSX.Element | false;
    addOnStyle?: string;
    options?: any,
    inputClass?: string,
    addOnContainerClass?: string,
}

export class InputExProps<T extends FieldValues> {
    static getClass = (props: { addOnBefore?: JSX.Element | false, addOnAfter?: JSX.Element | false, addOnStyle?: string, error?: object, inputClass?: string }) => {
        const {addOnBefore, addOnAfter, addOnStyle = 'inline', error, inputClass} = props;
        return `appearance-none block w-full px-3 py-2 border
                                        disabled:opacity-70 disabled:text-gray-900                         
                                        read-only:opacity-70 read-only:bg-sky-50 readOnly:text-gray-900
                                        ${addOnStyle === 'inline' || (!addOnBefore && !addOnAfter) ? 'rounded-l-md rounded-r-md' : ''} 
                                        ${(addOnStyle === 'inline' && addOnBefore) ? 'rounded-r-md rounded-l-none' : ''} 
                                        ${(addOnStyle === 'inline' && addOnAfter) ? 'rounded-l-md rounded-r-none' : ''} 
                                        ${(addOnStyle !== 'inline' && (addOnBefore || addOnAfter)) ? 'rounded-none flex-1' : ''} 
                                        ${(addOnStyle !== 'inline' && addOnBefore && !addOnAfter) ? 'rounded-r-md' : ''} 
                                        ${(addOnStyle !== 'inline' && addOnAfter && !addOnBefore) ? 'rounded-l-md' : ''}
                                        shadow-sm 
                                        placeholder-gray-400
                                        focus:outline-none
                                        focus:ring-blue-500
                                        focus:border-blue-500 sm:text-sm
                                        ${error ? 'border-rose-700' : 'border-gray-300'}
                                        ${(addOnStyle === 'inline' && addOnBefore) ? 'pl-9' : ''}
                                        ${(addOnStyle === 'inline' && addOnAfter) ? 'pr-9' : ''}
                                        ${inputClass}`;
    }
}

export function InputEx<T extends FieldValues>(props: InputExProps<T>) {
    const {
        addOnBefore,
        addOnAfter,
        addOnStyle = 'inline',
        errors,
        name,
        register,
        registerOptions,
        inputClass,
        addOnContainerClass = '',
        type = 'text',
        labelClassName = '',
        ...rest
    } = props;
    const message: string = errors ? (errors[name!] ? errors[name!]?.message : '') as string : '';
    // console.log('error: ', errors, message)

    let input: JSX.Element;
    if (props.input)
        input = props.input;
    else {
        if (!register && !rest.readOnly)
            throw new Error('Non hai specificato <register>!');
        const className = InputExProps.getClass({...props, error: message ? {} : undefined});
        input = (<>
            {register &&
                <>
                    <input id={name}
                           type={type}
                           {...rest}
                           {...register(name!, registerOptions)}
                           className={className}
                    />
                    {errors && errors[name!] && <p className="text-rose-700">{message}</p>}
                </>
            }
            {!register &&
                <>
                    <input id={name}
                           type={type}
                           {...rest}
                           className={className}
                    />
                </>
            }

        </>);
    }

//block w-full flex-1 rounded-none rounded-r-md border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
    return (
        <>
            {props.label && <label htmlFor={props.name}
                                   className={`block text-sm font-medium mb-1 ${props.disabled && 'opacity-70'} ${props.readOnly && 'opacity-70'} ${props.labelClassName}`}>
                {props.label}
            </label>}

            {!addOnBefore && !addOnAfter && input}

            {(addOnBefore || addOnAfter) && props.addOnStyle === 'inline' && <div className="relative mt-1 rounded-md shadow-sm">
                {addOnBefore &&
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        {addOnBefore}
                    </div>
                }

                {input}

                {addOnAfter &&
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        {addOnAfter}
                    </div>
                }
            </div>}

            {(addOnBefore || addOnAfter) && !props.addOnStyle && <div className={`flex rounded-md shadow-sm ${props.addOnContainerClass}`}>
                {addOnBefore &&
                    <div
                        className="min-w-[30px] max-w-[30px] place-content-center inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                        {addOnBefore}
                    </div>
                }

                {input}

                {addOnAfter &&
                    <div
                        className="min-h-8 min-w-[30px] max-w-[30px] place-content-center inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                        {addOnAfter}
                    </div>
                }
            </div>}
        </>
    );
}

/*export function InputCleave2<T extends FieldValues>(props: InputExProps<T>) {
    if (props.options) {
        if (!props.register)
            throw new Error('Non hai specificato <register>!');

        const {className, name, register} = props;
        const options = {};//{valueAsDate: true};
        const {onChange, onBlur, ref} = register(name, options);
        //const dt = formatDt((props.value ? props.value : '') as string);
        const dt = props.value ? props.value : '';

        const input = (<Cleave
            name={name}
            onChange={(v) => {
                onChange(v)
                console.log(v.target.value)
            }} onBlur={onBlur}
            value={dt}
            htmlRef={ref}
            options={props.options}
            className={className}
            disabled={props.disabled}
            readOnly={props.readOnly}
        />)
        return <InputEx {...{...props, input: input}}/>
    } else
        return <InputEx {...props}/>
}*/

interface InputCleaveProps<T extends FieldValues> {
    control: Control<T>,
    name: FieldPath<T>,
    label?: string,
    icon?: ReactNode,
    className?: string,
    data?: T[]
    isLoading?: boolean
    options: CleaveOptions,
    disabled?: boolean,
    readOnly?: boolean,
    placeholder?: string,
    rules?: Omit<RegisterOptions<T, FieldPath<T>>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>,
    onChange?: (v: string) => void,
    labelClassName?: string,
    addOnAfter?: ReactNode | boolean,
    style?: CSSProperties,
    errorPortalId?: string,
}

export function InputCleave<T extends FieldValues>(props: InputCleaveProps<T>) {

    return <Controller name={props.name}
                       control={props.control}
                       rules={props.rules}
                       render={({field: {value, onChange}, fieldState}) => {
                           //('valore da db ', value);
                           const errorMsg: string = fieldState.error ? (fieldState.error ? fieldState.error?.message : '') as string : '';
                           const errorMsgElement = errorMsg ? <p className="text-rose-700">{errorMsg}</p> : null;
                           return <>
                               {props.label && <>
                                   <label htmlFor={props.name}
                                          className={`block text-sm font-medium mb-1 ${props.disabled && 'opacity-70'} ${props.readOnly && 'opacity-70'} ${props.labelClassName || ''}`}>
                                       <span className="inline-flex">{props.label}&nbsp;{props.icon && props.icon}</span>
                                   </label>
                               </>}
                               <Cleave
                                   name={props.name}
                                   onChange={(e) => {
                                       /*let newValue: string;
                                       if (props.options.numeralDecimalMark === ',')
                                           newValue = e.target.rawValue.toString().replace(',', '.');
                                       else*/
                                       const newValue = e.target.rawValue;
                                       onChange(newValue);
                                       if (props.onChange)
                                           props.onChange(newValue);
                                       if (props.options.onValueChanged)
                                           props.options.onValueChanged(e);
                                       //console.log('valore da cleave', e.target.value, e.target.rawValue)
                                   }}
                                   value={value}
                                   options={props.options}
                                   className={`appearance-none block w-full px-3 border disabled:opacity-70 disabled:text-gray-900 read-only:opacity-70 read-only:bg-sky-50 read-only:text-gray-900
                                                shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm
                                                ${fieldState.error ? 'border-rose-700' : 'border-gray-300'} ${props.className} ${props.addOnAfter ? 'rounded-l-md rounded-r-none' : 'rounded-md'}`}
                                   disabled={props.disabled}
                                   readOnly={props.readOnly}
                                   placeholder={props.placeholder}
                                   style={props.style}
                               />
                               {props.errorPortalId && errorMsgElement && <FloatingPortal id={props.errorPortalId}>
                                   {errorMsgElement}
                               </FloatingPortal>}
                               {!props.errorPortalId && errorMsg && <p className="text-rose-700 text-balance">{errorMsg}</p>}
                           </>
                       }}
    />
}

/*
const InputExExample=()=>{
return (
<InputEx
type="text"
label="Attività"
name="attivita"
register={register}
errors={errors}
validation={Validation.required}
addOn={<TagIcon className="h-5 w-5 text-gray-400" aria-hidden="true"/>}>
</InputEx>
)
};
*/
export default InputEx;